export default () => ({
  scrollToHash(hash, failCallback = () => {}) {
    if (!hash) return failCallback?.();

    const hashItem = document.querySelector(hash);

    if (!hashItem) return failCallback?.();

    if ('scrollBehavior' in document.documentElement.style) {
      return window.scrollTo({ top: hashItem.offsetTop, behavior: 'smooth' });
    } else {
      return window.scrollTo(0, hashItem.offsetTop);
    }
  },
});
